export default __webpack_public_path__ + "static/media/news_2.4752dfc3.png";